import {
  Header,
  PageOrientation,
  Paragraph,
  SectionType,
  Footer,
  TextRun,
  AlignmentType,
  PageNumber,
} from "docx";
import { conclusionTableBrandenburg } from "./conclusionTableBrandenburg";
import { gutachterSectionArray } from "./gutachterSectionArray";
import { headerTable1, headerTable2 } from "./headerTables";
import { leseschwache } from "./leseschwaeche";
import { mainTable1 } from "./mainTable1";
import { mainTable2Brandenburg } from "./mainTable2Brandenburg";
import {
  paragraphArial,
  paragraphArialBold,
  paragraphArialBoldPageBreak,
} from "./paragraphs";
import { gutachterFieldBrandenburg } from "./gutachterFieldBrandenburg";

export const sectionsBrandenburg = (
  user,
  klausur,
  schueler,
  textbausteine,
  companies,

) => {
  const defaultHeader = new Header({
    children: [
      headerTable1(user, klausur, schueler),
      new Paragraph(""),
      headerTable2(user, klausur, schueler, companies),
      new Paragraph(""),
    ],
  });
  return [
    {
      properties: {
        titlePage: true,
        page: {
          type: SectionType.CONTINUOUS,
          size: {
            orientation: PageOrientation.PORTRAIT,
          },
          margin: {
            top: 400,
            right: 400,
            bottom: 400,
            left: 400,
          },
        },
      },
      headers: {
        default: defaultHeader,
        first: defaultHeader,
      },

      footers: {
        first: new Footer({
          children: [],
        }),
        default: new Footer({
          children: [
            new Paragraph({
              alignment: AlignmentType.CENTER,
              children: [
                new TextRun({
                  font: "arial",
                  children: [
                    "Seite ",
                    PageNumber.CURRENT,
                    " von ",
                    PageNumber.TOTAL_PAGES,
                  ],
                }),
              ],
            }),
          ],
        }),
      },
      children: [
        paragraphArialBold("Aufgabenbearbeitung"),
        mainTable1(user, klausur, schueler, textbausteine),
        paragraphArialBold("Sprachverwendung"),
        mainTable2Brandenburg(user, klausur, schueler, textbausteine),
        paragraphArialBold(schueler.zusammenfassung ? "Zusammenfassende Beurteilung / Bemerkungen" : ""),
        paragraphArial(schueler.zusammenfassung),
        paragraphArialBoldPageBreak("Gesamtbewertung"),
        conclusionTableBrandenburg(schueler, klausur),
        ...leseschwache(schueler.leseschwaeche),
        // ...gutachterSectionArray(schueler, klausur, companies, user),
        ...gutachterFieldBrandenburg(user)
      ],
    },
  ];
};
